import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import PersistenceRegistry from '../../base/redux/PersistenceRegistry';
import ReducerRegistry from '../../base/redux/ReducerRegistry';
import MMKVStorage from '../../../../react/native/Store/MMKVStorage';
const KEY_NAME = 'features/mobile-system';
const DEFAULT_ORGANIZATION = '';
const DEFAULT_JOINT_ORGANIZATIONS = [];
const initialState = {
    language: 'vi',
    organization: DEFAULT_ORGANIZATION,
    jointOrganization: DEFAULT_JOINT_ORGANIZATIONS,
    accounts: {}
};
const systemSlice = createSlice({
    name: KEY_NAME,
    initialState,
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setOrganization: (state, action) => {
            state.organization = action.payload;
            if (state.jointOrganization.includes(action.payload)) {
                return;
            }
            state.jointOrganization = [...state.jointOrganization, action.payload];
        },
        resetOrganization: (state) => {
            state.organization = DEFAULT_ORGANIZATION;
        },
        setAcountByOrganization: (state, action) => {
            const tempAccounts = { ...state.accounts };
            tempAccounts[action.payload.organization] = action.payload;
            state.accounts = tempAccounts;
        },
        removeAccountByOrganization: (state, action) => {
            const tempAccounts = { ...state.accounts };
            delete tempAccounts[action.payload.organization];
            state.accounts = tempAccounts;
        }
    }
});
const systemPersistConfig = {
    key: KEY_NAME,
    storage: MMKVStorage.mmkvReduxStorage // Use AsyncStorage for persistence
};
const pSystemReducer = persistReducer(systemPersistConfig, systemSlice.reducer);
ReducerRegistry.register(KEY_NAME, pSystemReducer);
PersistenceRegistry.register(KEY_NAME, pSystemReducer);
export const { setLanguage, setOrganization, resetOrganization, setAcountByOrganization, removeAccountByOrganization } = systemSlice.actions;
export default pSystemReducer;
